import { useContext } from "react";
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Icon,
  Box,
  Divider,
  Center,
} from "@chakra-ui/react";
import { BsShieldFillCheck } from "react-icons/bs";
import { HiOutlineExternalLink } from "react-icons/hi";

// Types
import Props from "./AuditInfoModal.type";

// Context
import { StakeContext } from "providers/StakeProvider";

// Constants
import {
  HALBORN_AUDIT_LINK,
  IMMUNEBYTES_AUDIT_LINK,
  IMMUNEFI_LINK,
} from "constants/contracts";
import { VIEW_AUDIT_REPORT, VIEW_BUG_BOUNTY } from "constants/analytics";

const AuditModal = ({ isOpen }: Props) => {
  const { closeModal, track } = useContext(StakeContext);

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent w="394px" bg="brand.backgroundLight">
        <ModalHeader fontSize="1rem" fontFamily="medium" fontWeight="500">
          Safe & secured
        </ModalHeader>
        <ModalCloseButton
          _focus={{
            boxShadow: "none",
          }}
        />
        <ModalBody pt="0" mb="1rem">
          <Center flexDir="column" mt="1rem" borderRadius="0.5rem">
            <Box
              fontSize="5rem"
              mb="1rem"
              color="brand.primary"
              _dark={{
                color: "brand.textColor",
              }}
            >
              <BsShieldFillCheck />
            </Box>
            <Text>Transparent & Regular Reviews</Text>
            <Text>Audited by Top Firms</Text>

            <Center mt="1rem" gap="1rem">
              <Flex
                as="a"
                cursor="pointer"
                color="brand.primary"
                href={HALBORN_AUDIT_LINK}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  track(VIEW_AUDIT_REPORT, { audit_type: "HALBORN" })
                }
                alignItems="center"
                gap="0.5rem"
              >
                <Text
                  fontFamily="medium"
                  borderBottom="2px dashed"
                  borderColor="brand.primary"
                >
                  Halborn
                </Text>
                <Icon as={HiOutlineExternalLink} />
              </Flex>
              <Flex
                as="a"
                cursor="pointer"
                color="brand.primary"
                href={IMMUNEBYTES_AUDIT_LINK}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  track(VIEW_AUDIT_REPORT, { audit_type: "IMMUNEBYTES" })
                }
                alignItems="center"
                gap="0.5rem"
              >
                <Text
                  fontFamily="medium"
                  borderBottom="2px dashed"
                  borderColor="brand.primary"
                >
                  ImmuneBytes
                </Text>
                <Icon as={HiOutlineExternalLink} />
              </Flex>
            </Center>
            <Divider borderColor="brand.separator" my="1.5rem" />
            <Center gap="0.5rem" flexDir="column">
              <Text>Report bug and earn bounty</Text>
              <Flex
                as="a"
                cursor="pointer"
                color="brand.primary"
                href={IMMUNEFI_LINK}
                target="_blank"
                rel="noreferrer"
                onClick={() => track(VIEW_BUG_BOUNTY, { platform: "IMMUNEFI" })}
                alignItems="center"
                gap="0.5rem"
              >
                <Text
                  fontFamily="medium"
                  borderBottom="2px dashed"
                  borderColor="brand.primary"
                >
                  Explore immunefi
                </Text>
                <Icon as={HiOutlineExternalLink} />
              </Flex>
            </Center>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AuditModal;
